import {Messages} from '../../@types/wishlist.js';

export function createLabel(
  messages: Messages,
  msgKeyPrefix: string,
  id: string,
): string {
  const idAsCamelCase = id
    .replace(/-([a-z0-9])/g, g => g[1].toUpperCase())
    .replace(/_([a-z0-9])/g, g => g[1].toUpperCase())
    .replace(/^(.)/, g => g[0]);
  const key = `${msgKeyPrefix}${idAsCamelCase}`;
  return messages[key] ?? `key ${key} is missing`;
}

export function createButtonLabelWithCount(
  messages: Messages,
  resultCount: number,
): string {
  const key = resultCount > 1 ? 'ents_wishlist_filter_showResults_many' : 'ents_wishlist_filter_showResults_one';
  const message = messages[key] ?? 'RESULT_COUNT';
  return message.replace('RESULT_COUNT', `${resultCount}`);
}
